// removed by extract-text-webpack-plugin
module.exports = {"BookingSummaryContainer":"_1ek-Y","BookingSummaryContainerFull":"_1egO9","BookingSummaryContainerActive":"_Dgnfe","Inner":"_3aRqp","InfoRow":"_1HPn6","InfoRowBottom":"_2NUMO","CloseIcon":"_1WKi3","ContainerFinal":"_3FDHB","ViewMoreButton":"_1ou_b","CloseImage":"_2vtJs","Item":"_2mCpX","ItemActive":"_2eyP7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Flight/FlightDetailsRoundTrip/FlightDetailsRoundTrip.scss
// module id = 706
// module chunks = 0